import React from "react"

import {FieldEditableValueNotEmptyProps} from "../../../../../proto/components/editable/value-not-empty"

export default function FieldDateRange_ControlViewNotEmpty(props:FieldEditableValueNotEmptyProps) {

    const showIcon  = _.get(props, 'configOptions.showIcon', true)

    const valueClasses = Classes("ui5-control-button s-28 hover-bg p-l-6 p-r-6", props.className, {
        "disabled": props.disabled
    })

    const onDeleteClick = () => {
        props.onChange?.(null)
    }

    let icon
    if (showIcon) {
        icon = _.get(props.field.components, 'ValueIcon', false)
        if (!icon && props.option.icon) {
            icon = <div className={Classes('ui5-ico-14 m-r-5', props.option.icon)}></div>
        }
    }

    return (
        <>
            <div className={valueClasses} onClick={props.onClick}>
                {icon}
                <div className="ui5-txt-not-important-small lh-13em w-100-percent txt-truncate">
                    {_.get(props.field.components, 'ValuePrefix', false)}
                    {props.field.getDisplayValue(props.value)}
                </div>

                {props.field.clearButton && <div className="ui5-ico-trash red s-14" onClick={onDeleteClick}/>}
            </div>
            {props.children}
        </>
    )
}
